export default "__VITE_ASSET__D4JZ3nib__"